export const getBooleanOptionValue = (value: boolean | null): string =>
  `${value}`;
